import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'
import { normalizeIt, sort } from 'utils/normalizr'

import * as Actions from 'actions/saved_searches'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  entities: {},
  result: [],
  sorted: []
})

export const addSorted = state => state.set('sorted', sort(
  state.get('result'),
  state.get('entities')
))

export const sortSavedSearches = (state, sortBy, direction) => state.update('sorted', sorted => {
  const newSorted = sorted.sortBy(savedSearch => {
    const value = savedSearch.get(sortBy)

    if (typeof value === 'string') {
      return value.toLowerCase()
    }

    return value
  })

  if (direction === 'desc') {
    return newSorted.reverse()
  }

  return newSorted
})

export default handleActions({
  [Actions.setSavedSearches]: (state, { payload: { savedSearches } }) => {
    const newState = addSorted(state.merge(fromJS(normalizeIt({ savedSearches }, 'savedSearch', 'savedSearches'))))

    // Apply default sorting by name
    return sortSavedSearches(newState, 'name', 'asc')
  },

  [Actions.refreshSavedSearchesSuccess]: (state, { payload: { savedSearches, requestedIds } }) => {
    const refreshedIds = savedSearches.map(savedSearch => savedSearch.id)
    const missingIds = requestedIds.filter(id => !refreshedIds.includes(id))

    return addSorted(state
      .update('entities', entities => entities.withMutations(next => {
        savedSearches.forEach(savedSearch => next.set(savedSearch.id, fromJS(savedSearch)))
        missingIds.forEach(id => next.delete(id))
      }))
      .update('result', result => result.filter(id => !missingIds.includes(id))))
  },

  [Actions.saveSavedSearchSuccess]: (state, { payload: savedSearch }) => addSorted(state
    .update('entities', entities => entities.set(savedSearch.id, fromJS(savedSearch)))
    .update('result', result => (result.includes(savedSearch.id) ? result : result.push(savedSearch.id)))),

  [Actions.deleteSavedSearchSuccess]: (state, { payload: id }) => addSorted(state
    .update('entities', entities => entities.delete(id))
    .update('result', result => result.filter(i => i !== id))),

  [AppActions.resetState]: () => initialState
}, initialState)
